import { MECState } from '../types'
import { createSlice } from '@reduxjs/toolkit'

const initialState: MECState = {
  isEditConsentPortal: null,
}

const mecPortalSlice = createSlice({
  name: 'mec',
  initialState: initialState,
  reducers: {
    updateEditConsentPortalData: (state: MECState, action) => {
      state.isEditConsentPortal = action.payload
    }
  },
})

export const {
updateEditConsentPortalData
} = mecPortalSlice.actions
export default mecPortalSlice.reducer
